<template>
	<Page>
		<div class="centered">
			<Breadcrumb :crumbs="[
					{
						text : 'Home',
						to : {name:'templates'},
					},
					{
						text : 'Organisations',
						to : {name:'orgs'},
					},
					{
						text : org.name || 'Personal projects',
						to : {name:'org',params:{org_id:org.id}},
					},
				]" />
			<OrgNav :org="org" />
			<router-view :org="org" ></router-view>
		</div>
	</Page>
</template>

<script>

	import Page from '../mixins/Page'
	import OrgNav from '../components/OrgNav';
	import Breadcrumb from '../components/Breadcrumb'

	export default {
		components: {OrgNav,Breadcrumb},
		mixins : [Page],
		computed : {
			org : function(){
				return this.$store.state.auth.orgs.find(x=>x.id==this.$route.params.org_id);
			},
		},
	}

</script>